import BaseMapper from '../../BaseMapper';

const OutcomeMapper = (data, context = {}) => {
    const { changeType = data.changeType } = context;

    data.closed = typeof data.odd !== 'number' || data.odd < 0.01 || data.status > 0;

    data.changeType = changeType;

    return data;
};

export default OutcomeMapper;
